// 9fbef606107a605d69c0edbcd8029e5d
import { executeStatefulAPICall } from '../../handler';
import endpoints from '../../endpoints';

const claimPoints = (payload) => {
  const payloadData = {
    body: {
      firstName: payload.firstName,
      lastName: payload.lastName,
      myPlaceNumber: payload.myPlaceNumber,
      emailAddress: payload.email,
      storeType: payload.wasInStoreTransaction ? 'S' : 'O',
      storeNum: payload.wasInStoreTransaction ? payload.storeNumber : '0180',
      registerNum: payload.storeRegisterNumber,
      transNum: payload.transactionNumber,
      transDate: payload.transactionDate,
      orderNum: payload.orderNumber,
    },
    webService: endpoints.claimPoints,
  };
  return executeStatefulAPICall(payloadData)
    .then((res) => {
      if (!res) {
        throw new Error('res body is null');
      }
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export default claimPoints;
